import dayjs, { ConfigType, Dayjs } from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';

dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.locale(process.env.GATSBY_LOCALE || 'fr');

export const fromNow = (date: ConfigType) => {
  return dayjs(date).fromNow();
};

export const fromNowDetailed = (date: ConfigType) => {
  const now: Dayjs = dayjs();
  const targetDate: Dayjs = dayjs(date);
  const timeLeft = dayjs.duration(targetDate.diff(now));

  return {
    days: timeLeft.days(),
    hours: timeLeft.hours(),
    minutes: timeLeft.minutes(),
    seconds: timeLeft.seconds()
  };
};

export const isOutdated = (date: ConfigType) => {
  return dayjs().isAfter(dayjs(date));
};

/**
 * @see dayjs.Dayjs.format
 * ```
 * 'dddd DD MMMM' for Wednesday 01 December
 * ```
 */
export type DateTemplate = string;

export const dateFormat = (date: ConfigType, template: DateTemplate) => {
  return dayjs(date).format(template);
};
